import Vue    from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
                              routes: [
                                  {
                                      path     : "/",
                                      redirect : "/dashboard",
                                      component: () => import("@/pages/Layout"),
                                      children : [
                                          {
                                              name     : "dashboard",
                                              path     : "/dashboard",
                                              component: () => import("@/pages/Dashboard")
                                          },
                                          {
                                              name     : "houseProcessing",
                                              path     : "/houseProcessing",
                                              component: () => import("@/pages/HouseProcessing")
                                          },
                                          {
                                              name     : "houseDone",
                                              path     : "/houseDone",
                                              component: () => import("@/pages/HouseDone")
                                          },
                                          {
                                              name     : "houseTender",
                                              path     : "/houseTender",
                                              component: () => import("@/pages/HouseTender")
                                          },
                                          {
                                              name     : "housePlain",
                                              path     : "/housePlain",
                                              component: () => import("@/pages/HousePlain")
                                          },
                                          {
                                              name     : "houseAlmost",
                                              path     : "/houseAlmost",
                                              component: () => import("@/pages/HouseAlmost")
                                          },
                                      ]
                                  }
                              ]
                          });
